<!-- <img *ngIf="compantData" src="{{compantData?.logo}}" class="img" /> -->
<span
  *ngIf="compantData"
  (click)="companyPage(compantData.name)"
  class="comp-name"
  >{{ compantData.name }}</span
>
